import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const AvailableVenteVusTable = Loadable(lazy(() => import('pages/promoove/availableVenteVusTable')));
const AvailableFinanceVusTable = Loadable(lazy(() => import('pages/promoove/availableFinanceVusTable')));
const AvailableVuDetails = Loadable(lazy(() => import('pages/promoove/availableVuDetails')));

// ==============================|| CARS ROUTING ||============================== //

const PromooveRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'available-vente-vu',
          element: <AvailableVenteVusTable />
        },
        {
          path: 'available-finance-vu',
          element: <AvailableFinanceVusTable />
        },
        {
          path: '/available-finance-vu/:id',
          element: <AvailableVuDetails />
        }
      ]
    }
  ]
};

export default PromooveRoutes;
